// removed by extract-text-webpack-plugin
module.exports = {"root":"GenericSettingsSubHeader__root___23c-r"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/GenericSettings/GenericSettingsSubHeader/GenericSettingsSubHeader.scss
// module id = 1030
// module chunks = 0